import { CheckboxStyled } from '../CheckboxStyled';
import styled from 'styled-components';
import { rem } from 'polished';

export const CheckboxStyledOV = styled(CheckboxStyled)`
    .container input + label::after {
        color: ${({ theme }) => theme.colors.black};
    }
`;
